export default "__VITE_ASSET__ogoKtqwO__"